import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import incidentReducer from './slices/incidentSlice';
import notificationReducer from './slices/notificationSlice';
import alertReducer from './slices/alertSlice';
//import { thunk } from 'redux-thunk';  // Correct import

const store = configureStore({
  reducer: {
    auth: authReducer,
    incidents: incidentReducer,
    notifications: notificationReducer,
    alert: alertReducer,
  },
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
console.log('Initial Redux State:', store.getState()); // Log initial state
export default store;
